import { useState, useEffect } from 'react';
import { usePublisherStore } from '../../../store/models/publisher';
import usePublisher from '../../../store/models/publisher/usePublisher';

function useDirectorySearch() {
    const publisherStore = usePublisherStore();
    const {
        directoryPublishers,
        directoryFilterIndustries,
        filteredDirectoryPublishers,
        search,
    } = usePublisher();

    const [searchInputValue, setSearchInputValue] = useState('');

    // Local activeIndustries — updates immediately so pills toggle without
    // waiting for the store observable round-trip
    const [activeIndustries, setActiveIndustries] = useState([]);

    // Debounce searchText — only dispatch to store after 300ms of no typing
    useEffect(() => {
        const timer = setTimeout(() => {
            publisherStore.setSearchText(searchInputValue);
        }, 300);
        return () => clearTimeout(timer);
    }, [searchInputValue]);

    function handleToggleIndustry(industry) {
        const updated = activeIndustries.includes(industry)
            ? activeIndustries.filter((i) => i !== industry)
            : [...activeIndustries, industry];
        setActiveIndustries(updated);
        publisherStore.toggleIndustryFilter(industry);
    }

    function handleClearIndustries() {
        setActiveIndustries([]);
        publisherStore.clearIndustryFilters();
    }

    return {
        industries: directoryFilterIndustries,   // all available — feed into pill list
        activeIndustries,                         // currently toggled — drives active state
        searchInputValue,
        whatshotEnabled: search.whatshotEnabled,
        directoryPublishers,
        filteredDirectoryPublishers,
        onSearchText: (text) => setSearchInputValue(text),
        onToggleWhatshot: (enabled) => publisherStore.setWhatshotEnabled(enabled),
        onToggleIndustry: handleToggleIndustry,
        onClearIndustries: handleClearIndustries,
    };
}

export default useDirectorySearch;
